import { useState, useEffect, useCallback } from 'react';
import { PolicyRevision, PolicyType } from '../types';
import { apiService } from '../services/api';
import { subscribeRevisions } from '../services/firestore';

export const useCompanyTimeline = (companyId: string, policyType: PolicyType = 'terms_of_service') => {
  const [revisions, setRevisions] = useState<PolicyRevision[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchTimeline = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await apiService.getRevisions(companyId, policyType);
      setRevisions(data || []);
    } catch (err: any) {
      console.warn(`[useCompanyTimeline] Fetch note for ${companyId}/${policyType}:`, err.message);
    } finally {
      setLoading(false);
    }
  }, [companyId, policyType]);

  useEffect(() => {
    setLoading(true);
    // Subscribe to live Firestore collection
    const unsubscribe = subscribeRevisions(
      companyId,
      policyType,
      (liveRevs) => {
        setRevisions(liveRevs || []);
        setLoading(false);
      },
      (err) => {
        console.warn(`[useCompanyTimeline] Listener note for ${companyId}/${policyType}:`, err.message);
        fetchTimeline();
      }
    );

    return () => unsubscribe();
  }, [companyId, policyType, fetchTimeline]);

  return { revisions, loading, error, refreshTimeline: fetchTimeline };
};
